module.exports = __webpack_public_path__ + "static/media/An open platform to provide service.1cbce98b.png";